/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_TranscriptionInputs */



/**
* | output |
* | --- |
* | "Offline Transcription" |
*
* @param {Offline_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_transcription = /** @type {((inputs?: Offline_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Офлайн-транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフライン文字起こし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन प्रतिलेखन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição offline")
	return /** @type {LocalizedString} */ ("Offline Transcription")
});